import {
	ONBOARDING_ACTIVATION_LOGGEDIN,
	ONBOARDING_ACTIVATION_FORGOT_EMAIL,
	ONBOARDING_ACTIVATION_LOGOUT,
	ONBOARDING_ACTIVATION_SWITCH,
	ACCOUNT_FORGOT_EMAIL,
} from '../../constants/Copy';
import { ROUTE_LOGOUT } from '../../constants/Routes';
import React from 'react';
import { useGetUserInfo } from '../../hooks/useGetUserInfo';
import { hasValidVideolandCookie } from '../../helpers/authentication';
import { getConfig } from '../../apiConfig';

export const UserStatusLoggedIn = ({ hideLogout = false, hideStatus = false, redirectUrl }) => {
	const {
		user: { email },
		loading,
	} = useGetUserInfo();

	if (!hasValidVideolandCookie() || loading) {
		return null;
	}

	const { identity_host } = getConfig();

	return (
		<div className="userstatus__loggedin" data-test="user-status-logged-in">
			{!hideStatus && (
				<>
					{ONBOARDING_ACTIVATION_LOGGEDIN} <span className="userstatus__email">{email}</span>.
				</>
			)}

			{!hideStatus && !hideLogout && <br />}
			{!hideLogout && (
				<div className="logout-forgot_email__wrapper">
					<div>
						<p>{ONBOARDING_ACTIVATION_SWITCH} </p>
						<a
							href={`${ROUTE_LOGOUT}${redirectUrl ? `?redirect=${redirectUrl}` : ''}`}
							className="onboarding__link"
						>
							{ONBOARDING_ACTIVATION_LOGOUT}
						</a>
					</div>
					<div>
						<p>{ONBOARDING_ACTIVATION_FORGOT_EMAIL}</p>
						<a
							href={`${identity_host}/oidc/forgot-email?client_id=videoland`}
							className="onboarding__link"
							target="_blank"
							rel="noopener noreferrer nofollow"
						>
							{ACCOUNT_FORGOT_EMAIL}
						</a>
					</div>
				</div>
			)}
		</div>
	);
};
